import { ActionCreatorsMapObject, bindActionCreators, combineReducers } from 'redux';
import { useDispatch } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { useMemo } from 'react';

import { sessionReducer } from './session/reducer';
import { appSettingsReducer } from './appSettings/reducer';

const rootReducer = combineReducers({
    session: sessionReducer,
    appSettings: appSettingsReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export const useActions = <A, M extends ActionCreatorsMapObject<A>>(actions: M) => {
    const dispatch = useDispatch();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const memoizedActions = useMemo(() => bindActionCreators(actions, dispatch), []);

    return memoizedActions;
};

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV === 'development',
});
